import React from 'react';
import Select from 'react-select';

const seasonWithID = (id, seasons) => seasons.find(season => season.id === id)

const SeasonSelect = ({ seasons, activeSeasonID, setActiveSeason, handleCtaClick }) => {
  if (seasons.length === 0) return null

  return(
    <div className="select-container">
      <label>Season</label>
      <Select
        value={seasonWithID(activeSeasonID, seasons)}
        onChange={setActiveSeason}
        options={seasons}
        valueKey="id"
        labelKey="span"
        clearable={false}
      />
      <button
        type="button"
        className="cta"
        onClick={handleCtaClick}
      >
        + Add Season
      </button>
    </div>
  )
}


export default SeasonSelect



// WEBPACK FOOTER //
// ./src/components/UserPortal/Locker/Stats/SeasonSelect.js